/*
 * RequestOffer Messages
 *
 * This contains all the text for the RequestOffer container.
 */
import { defineMessages } from 'react-intl';

export const scope = 'app.components.RequestOffer';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: "Non hai trovato l'auto che cercavi?",
  },
  description: {
    id: `${scope}.description`,
    defaultMessage: "Facci sapere quale auto stai cercando e ti contatteremo noi!",
  },
  action: {
    id: `${scope}.action`,
    defaultMessage: "Trova auto",
  },
});
